<div class="grid grid-cols-12 gap-3">
  <div class="icon">
    <i class="fa-light fa-file-invoice"></i>
  </div>
  <div class="detail">
    <div class="flex flex-col gap-1">
      <span class="text-base font-sans">{{ meeting.title }}</span>
      <div class="flex flex-col">
        <span>{{ meeting.start | date: 'medium' }}</span>
        <span *ngIf="meeting.extendedProps.recurrence">{{ meeting.extendedProps.recurrence | recurrence }}</span>
      </div>
    </div>
  </div>
  <ng-container *ngIf="isPast && meeting.extendedProps.recording">
    <div class="icon">
      <i class="fa-light fa-video"></i>
    </div>
    <div class="detail">
      <a [href]="meeting.extendedProps.recording" target="_blank" class="text-blue-500">{{ meeting.extendedProps.recording }}</a>
    </div>
  </ng-container>
  <ng-container *ngIf="showAISummaryURL">
    <div class="icon">
      <i class="fa-light fa-robot" pTooltip="AI Summary" tooltipPosition="top"></i>
    </div>
    <div class="detail">
      <a [href]="meeting.extendedProps.ai_summary_url" target="_blank" class="text-blue-500">{{ meeting.extendedProps.ai_summary_url }}</a>
    </div>
  </ng-container>
  <ng-container *ngIf="!isPast">
    <div class="icon">
      <i class="fa-light fa-map-marker-alt"></i>
    </div>
    <div class="detail">
      <a [href]="meeting.extendedProps.share_url" target="_blank" class="text-blue-500"> {{ meeting.extendedProps.share_url }}</a>
    </div>
    <div class="icon">
      <i class="fa-light fa-id-card-alt"></i>
    </div>
    <div class="detail">
      <span>{{ meeting.extendedProps.meeting_id }}</span>
      <i
        class="fa-light fa-link cursor-pointer text-primary"
        [cdkCopyToClipboard]="occurrenceLink"
        [pTooltip]="copyTooltip"
        (cdkCopyToClipboardCopied)="onCopy()"
        [tooltipOptions]="{ hideDelay }"></i>
    </div>
  </ng-container>
  <div class="icon">
    <i class="fa-light fa-users"></i>
  </div>
  <div class="detail">
    <span>{{ meeting.extendedProps.registrant_count }} Participants</span>
  </div>
  <ng-container *ngIf="meeting.extendedProps.agenda">
    <div class="icon">
      <i class="fa-light fa-file-alt"></i>
    </div>
    <div class="detail">
      <span lfxShowMore [maxLength]="150" [innerHTML]="meeting.extendedProps.agenda | clickableLinks"></span>
    </div>
  </ng-container>
  <ng-container *ngIf="!isPast && !meeting.extendedProps.restricted">
    <div class="icon"></div>
    <div class="detail">
      <a
        pButton
        type="button"
        label="Register"
        size="small"
        class="p-button-primary"
        [href]="meeting.extendedProps.share_url + '&invite=true'"
        target="_blank"></a>
    </div>
  </ng-container>
</div>
